import type { ReactNode } from "react";
import type { RouteObject } from "react-router-dom";
import { Guarded } from "./kit";
import { section, type SettingsSection } from "./sections";
import { BranchPage, BranchesPage, HolidaysPage } from "./BranchPages";
import { CataloguePage, CouponPage, CouponsPage, ItemPage } from "./CataloguePages";
import { AuditPage, ProfilePage, SettingsIndex } from "./AuditProfileIndex";
import { DevicesPage, IntakeKeysPage, LeadStagesPage, MessagingPage, PaymentAccountsPage } from "./OtherPages";
import { routes as onboarding } from "../onboarding/routes";
import { RolePage, RolesPage } from "./RolesPages";
import { AttendancePage, BusinessPage, PtSchedulePage, CommissionPage, InvoicingPage, LeadsSettingsPage, MembershipsPage, PayrollPage } from "./SectionPages";

/** One route per section; each is guarded by its section's levers from `sections.ts`, the same table the index tiles use. */
const g = (key: SettingsSection, el: ReactNode) => <Guarded allow={section(key)}>{el}</Guarded>;

export const routes: RouteObject[] = [
  { path: "settings", element: <SettingsIndex /> },
  { path: "settings/business", element: g("business", <BusinessPage />) },
  { path: "settings/branches", element: g("branches", <BranchesPage />) },
  { path: "settings/branches/:id", element: g("branches", <BranchPage />) },
  { path: "settings/invoicing", element: g("invoicing", <InvoicingPage />) },
  { path: "settings/memberships", element: g("memberships", <MembershipsPage />) },
  { path: "settings/commission", element: g("commission", <CommissionPage />) },
  { path: "settings/payroll", element: g("payroll", <PayrollPage />) },
  { path: "settings/leads", element: g("leads", <LeadsSettingsPage />) },
  { path: "settings/attendance", element: g("attendance", <AttendancePage />) },
  { path: "settings/pt-schedule", element: g("pt-schedule", <PtSchedulePage />) },
  { path: "settings/holidays", element: g("holidays", <HolidaysPage />) },
  { path: "settings/catalogue", element: g("catalogue", <CataloguePage />) },
  { path: "settings/catalogue/:id", element: g("catalogue", <ItemPage />) },
  { path: "settings/coupons", element: g("coupons", <CouponsPage />) },
  { path: "settings/coupons/:id", element: g("coupons", <CouponPage />) },
  { path: "settings/payment-accounts", element: g("payment-accounts", <PaymentAccountsPage />) },
  { path: "settings/roles", element: g("roles", <RolesPage />) },
  { path: "settings/roles/:id", element: g("roles", <RolePage />) },
  { path: "settings/lead-stages", element: g("lead-stages", <LeadStagesPage />) },
  { path: "settings/intake-keys", element: g("intake-keys", <IntakeKeysPage />) },
  { path: "settings/devices", element: g("devices", <DevicesPage />) },
  { path: "settings/audit", element: g("audit", <AuditPage />) },
  { path: "settings/messaging", element: g("messaging", <MessagingPage />) },
  { path: "settings/profile", element: <ProfilePage /> },
  // The import wizard lives in features/onboarding; each page guards itself with section("imports").
  ...onboarding,
];
